/* IM Quick View – logique (image, titre, prix, tailles, flocage, CTA) */
(() => {
  /* log retiré (prod) */

  const root = document.getElementById('im-qv');
  if (!root) return;

  // --- DOM refs
  const title        = root.querySelector('#im-qv-title');
  const priceNode    = root.querySelector('#im-qv-price');
  const thumb        = root.querySelector('#im-qv-thumb');
  const form         = root.querySelector('#im-qv-form');
  const optBox       = root.querySelector('#im-qv-options');
  const varId        = root.querySelector('#im-qv-variant-id');
  const btnAdd       = root.querySelector('.im-qv__submit');
  const sizeCurrent  = root.querySelector('#im-qv-size-current');
  const liveCount    = root.querySelector('#im-qv-livecount');

  // Flocage
  const flocageToggle = root.querySelector('#im-qv-flocage');
  const flocageFields = root.querySelector('#im-qv-flocage-fields');
  const numeroInput   = root.querySelector('input[name="properties[Numéro]"]');
  const numeroHint    = root.querySelector('.im-qv__hint');
  const nomInput      = root.querySelector('input[name="properties[Nom]"]');
  const subInput      = root.querySelector('input[name="properties[Sous le numéro]"]');
  const qvJName       = root.querySelector('[data-im-qv-name]');
  const qvJNumber     = root.querySelector('[data-im-qv-number]');
  const qvJSub        = root.querySelector('[data-im-qv-sub]');

  // --- State
  let product = null;
  let currentVariant = null;
  let selections = {}; // { 'Taille': 'S', ... }
  let isOpen = false;
  const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

  // --- Utils
  const money = (cents) => {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: cur
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Produit introuvable');
    return res.json();
  };

  // Nombre "personnes consultent ce produit" réaliste et différent par produit.
  const getLiveCountFromSeed = (seed) => {
    if (!seed) return 12;
    let hash = 0;
    for (let i = 0; i < seed.length; i += 1) {
      hash = ((hash << 5) - hash) + seed.charCodeAt(i);
      hash |= 0;
    }

    const min = 5;
    const max = 18;
    const base = min + (Math.abs(hash) % (max - min + 1));
    const dayBucket = Math.floor(Date.now() / 86400000);
    const drift = ((Math.abs(hash + dayBucket) % 3) - 1); // -1, 0, +1

    return Math.max(min, Math.min(max, base + drift));
  };

  const getLiveCountForProduct = (p) => {
    if (!p) return 12;
    return getLiveCountFromSeed(`${p.id || ''}-${p.handle || ''}-${p.title || ''}`);
  };

  // --- Open / Close (sans empilement de listeners)
  let closeTimer = null; // click-fix 29/08 : timer robuste (transitionend peut ne jamais tirer)
  const open = () => {
    if (isOpen) return;
    isOpen = true;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    root.style.display = 'block';
    // force reflow pour activer la transition CSS
    // eslint-disable-next-line no-unused-expressions
    root.offsetHeight;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const close = () => {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      closeTimer = null;
      if (!isOpen) root.style.display = 'none';
    }, 450); /* click-fix 29/08 : remplace transitionend (jamais garanti) — même délai que la transition, aucun rendu changé */
  };

  // Fermer : scrim / bouton / ESC
  root.addEventListener('click', (e) => {
    if (e.target.closest('.im-qv__scrim,[data-im-qv-close]')) {
      e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (isOpen && e.key === 'Escape') close();
  });

  // --- Variants
  const setVariantBySelections = () => {
    if (!product) return;
    const v = product.variants.find((variant) =>
      product.options.every((opt, i) => {
        const wanted = selections[opt.name] ?? variant[`option${i + 1}`];
        return variant[`option${i + 1}`] === wanted;
      })
    ) || product.variants[0];

    currentVariant = v;
    if (varId) varId.value = v.id;
    if (priceNode) priceNode.textContent = money(v.price);
    if (btnAdd) btnAdd.disabled = !v.available;

    const sizeOpt = product.options.find((o) => /size|taille/i.test(o.name));
    if (sizeCurrent) {
      if (sizeOpt) {
        const idx = product.options.indexOf(sizeOpt);
        sizeCurrent.textContent = v[`option${idx + 1}`] || '—';
      } else {
        sizeCurrent.textContent = '—';
      }
    }
  };

  const renderOptions = () => {
    if (!optBox) return;
    optBox.innerHTML = '';
    selections = {};

    const ordered = [...product.options].sort((a, b) => {
      const as = /size|taille/i.test(a.name) ? -1 : 0;
      const bs = /size|taille/i.test(b.name) ? -1 : 0;
      return as - bs;
    });

    ordered.forEach((opt) => {
      const realIndex = product.options.findIndex((o) => o.name === opt.name);
      const values = [...new Set(product.variants.map((v) => v[`option${realIndex + 1}`]))];

      const group = document.createElement('div');
      group.className = 'im-qv__opt-group';

      values.forEach((val) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'im-qv__opt-btn';
        btn.textContent = val;
        btn.dataset.optName = opt.name;
        btn.dataset.optIndex = String(realIndex);

        btn.addEventListener('click', () => {
          optBox.querySelectorAll(`.im-qv__opt-btn[data-opt-name="${CSS.escape(opt.name)}"]`)
            .forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selections[opt.name] = val;
          setVariantBySelections();
        });

        group.appendChild(btn);
      });

      optBox.appendChild(group);
    });

    const v0 = product.variants.find((v) => v.available) || product.variants[0];
    product.options.forEach((opt, i) => (selections[opt.name] = v0[`option${i + 1}`]));

    Object.entries(selections).forEach(([name, val]) => {
      optBox.querySelectorAll(`.im-qv__opt-btn[data-opt-name="${CSS.escape(name)}"]`)
        .forEach((el) => { if (el.textContent === val) el.classList.add('is-active'); });
    });

    setVariantBySelections();
  };

  const renderProduct = (p) => {
    product = p;
    if (title) title.textContent = product.title;
    if (priceNode) priceNode.textContent = money(product.price || product.variants[0].price);
    if (liveCount) liveCount.textContent = String(getLiveCountForProduct(product));
    if (thumb) {
      thumb.innerHTML = (product.images && product.images.length)
        ? `<img src="${product.images[0]}" alt="${product.title}">`
        : '';
    }
    renderOptions();
  };

  // --- Flocage (stable)
  const updateFlocageVisibility = () => {
    if (!flocageToggle || !flocageFields) return;
    const on = !!flocageToggle.checked;

    // Montre/Cache
    flocageFields.hidden = !on;
    flocageFields.style.display = on ? 'block' : 'none';

    // Active/Désactive inputs SANS les vider (on ne touche pas à la valeur saisie)
    flocageFields.querySelectorAll('input,select,textarea,button').forEach((el) => {
      el.disabled = !on;
    });

    if (!on && numeroHint) numeroHint.textContent = '';
  };

  // Aperçu flocage LIVE (dos du maillot) — reflète Nom / Numéro / Sous le numéro
  const syncQvJersey = () => {
    if (qvJName)   qvJName.textContent = ((nomInput && nomInput.value) || '').toUpperCase().slice(0, 14) || 'GRINTA';
    if (qvJNumber) {
      const n = ((numeroInput && numeroInput.value) || '').replace(/[^\d]/g, '').slice(0, 4);
      qvJNumber.textContent = n || '10';
      qvJNumber.style.fontSize = (n.length > 2 ? 42 : 52) + 'px';
    }
    if (qvJSub) qvJSub.textContent = ((subInput && subInput.value) || '').toUpperCase().slice(0, 16);
  };

  // Numéro : seulement chiffres, max 4 (aligné sur la fiche produit) — validation douce
  const handleNumeroInput = () => {
    if (!numeroInput) return;
    const onlyDigits = numeroInput.value.replace(/[^\d]/g, '');
    if (onlyDigits !== numeroInput.value) {
      numeroInput.value = onlyDigits;
    }
    if (numeroInput.value.length > 4) {
      numeroInput.value = numeroInput.value.slice(0, 4);
    }
    if (numeroHint) numeroHint.textContent = '';
    syncQvJersey();
  };

  // Attacher 1 seule fois
  flocageToggle?.addEventListener('change', updateFlocageVisibility);
  numeroInput?.addEventListener('input', handleNumeroInput);
  nomInput?.addEventListener('input', syncQvJersey);
  subInput?.addEventListener('input', syncQvJersey);

  // --- Ajout panier
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!currentVariant) return;
    btnAdd.disabled = true;

    try {
      const fd = new FormData(form);
      // Ne jamais envoyer de propriétés de flocage VIDES (pollution des commandes /
      // Sheet fournisseur) — même comportement que la fiche produit.
      ['properties[Nom]', 'properties[Numéro]', 'properties[Sous le numéro]'].forEach((k) => {
        const v = (fd.get(k) || '').toString().trim();
        if (!v) fd.delete(k);
      });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) {
        let msg = 'Erreur ajout panier';
        try {
          const errData = await res.json();
          if (errData && (errData.description || errData.message)) {
            msg = errData.description || errData.message;
          }
        } catch (_) {}
        throw new Error(msg);
      }

      // Notify thème / cart drawer qu'un item a été ajouté
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      // Ferme la popup mobile
      close();

      // Ouvre le cart drawer via l'API IMCart (avec fallback)
      setTimeout(() => {
        if (window.IMCart && typeof window.IMCart.open === 'function') {
          window.IMCart.open();
        } else {
          const trigger = document.querySelector('[data-im-open-cart], [data-cart-trigger], .js-open-cart, [href="#cart-drawer"], .js-mini-cart');
          if (trigger) trigger.click();
        }
      }, 120);
    } catch (err) {
      console.error('[IM mobile popup] add-to-cart failed:', err);
      btnAdd.disabled = false;
      // Affiche le message d'erreur dans la popup (sans alert bloquant)
      const errBox = form.querySelector('[data-im-error]') || (() => {
        const el = document.createElement('div');
        el.setAttribute('data-im-error', '');
        el.style.cssText = 'color:#c33;font-size:13px;margin-top:8px;text-align:center;';
        form.appendChild(el);
        return el;
      })();
      errBox.textContent = err.message || 'Une erreur est survenue, réessayez.';
      setTimeout(() => { errBox.textContent = ''; }, 4000);
    }
  });

  // --- Ouverture QV
  window.addEventListener('im:qv:open', async (ev) => {
    if (isDesktop()) return;
    open();

    // UI placeholders
    btnAdd.disabled = true;
    if (liveCount) liveCount.textContent = String(getLiveCountFromSeed(ev?.detail?.handle || 'default'));
    title.textContent = 'Chargement…';
    priceNode.textContent = '';
    thumb.innerHTML = '<div style="width:90px;height:90px;background:#f3f3f3;border-radius:14px;"></div>';
    optBox.innerHTML = '<div style="padding:12px 0;color:#999;text-align:center;">Préparation des tailles…</div>';
    if (sizeCurrent) sizeCurrent.textContent = '—';

    // Flocage OFF par défaut à l’ouverture
    if (flocageToggle) flocageToggle.checked = false;
    updateFlocageVisibility();

    try {
      const p = await fetchProduct(ev.detail.handle);
      renderProduct(p);
      // Valide la disponibilité du variant courant
      btnAdd.disabled = !(currentVariant?.available ?? true);
    } catch (e) {
      console.error(e);
      title.textContent = 'Produit indisponible';
      btnAdd.disabled = true;
    }
  });

  // --- TRIGGER (bouton sur la carte produit)
  document.addEventListener('click', (e) => {
    if (isDesktop()) return;
    const btn = e.target.closest('.im-mpb, [data-im-qv-open]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    window.dispatchEvent(new CustomEvent('im:qv:open', { detail: { handle } }));
  }, true);
})();

/* QV – cacher la bulle à l'ouverture, la remettre à la fermeture (robuste) */
(() => {
  const qv = document.getElementById('im-qv');
  if (!qv) return;

  // 1) Sélecteurs connus + fallback heuristique (bulle fixe en bas à droite)
  const KNOWN = [
    '.shopify-chat-bubble',
    '.gorgias-chat', '#gorgias-chat-container', 'iframe[src*="gorgias"]',
    '.tidio-chat', '#tidio-chat', 'iframe[src*="tidio"]',
    '.crisp-client', 'iframe[src*="crisp"]',
    '.intercom-lightweight-app', 'iframe[src*="intercom"]',
    '#tawkchat-minified', 'iframe[src*="tawk"]',
    '#hubspot-messages-iframe-container', 'iframe[id^="launcher"]'
  ];
  const FALLBACK_CANDIDATES = [
    'iframe[src*="chat"]',
    'iframe[id*="chat"]',
    '[id*="chat"]',
    '[class*="chat"]',
    '[id*="launcher"]',
    '[class*="launcher"]'
  ].join(',');

  const saved = new WeakMap();

  const collectWidgets = () => {
    const set = new Set();
    KNOWN.forEach(s => document.querySelectorAll(s).forEach(el => set.add(el)));

    // Fallback limité: on évite un scan complet de tout le DOM.
    document.querySelectorAll(FALLBACK_CANDIDATES).forEach(el => {
      if (!(el instanceof HTMLElement) || qv.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      const nearBR = (innerWidth - r.right < 180) && (innerHeight - r.bottom < 180);
      const small  = r.width <= 360 && r.height <= 360;
      const zi     = parseInt(cs.zIndex || '0', 10);
      if ((nearBR && small && zi > 1000) || (el.tagName === 'IFRAME' && zi > 1000)) set.add(el);
    });

    return [...set];
  };

  const hide = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) saved.set(el, el.getAttribute('style') || '');
      el.style.cssText += ';opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
    });
  };

  const show = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) return;
      const s = saved.get(el);
      s ? el.setAttribute('style', s) : el.removeAttribute('style');
      saved.delete(el);
    });
  };

  const isOpen = () => {
    const cs = getComputedStyle(qv);
    return qv.classList.contains('is-open') ||
           qv.getAttribute('aria-hidden') === 'false' ||
           cs.display !== 'none';
  };

  const sync = () => (isOpen() ? hide() : show());
  let syncTimer = null;
  const scheduleSync = (delay = 80) => {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay);
  };

  // 2) Réagit aux changements d’état (open/close)
  new MutationObserver(() => scheduleSync(0)).observe(qv, {
    attributes: true,
    attributeFilter: ['class','style','aria-hidden']
  });
  new MutationObserver(() => scheduleSync(120)).observe(document.body, {
    childList: true,
    subtree: true
  });

  // 3) Hooks explicites : ton code déclenche déjà im:qv:open ; on écoute aussi la fermeture
  window.addEventListener('im:qv:open', () => scheduleSync(0));
  document.addEventListener('click', e => {
    if (e.target.closest('[data-im-qv-close]') || e.target.closest('.im-qv__scrim, .im-qv__backdrop')) {
      scheduleSync(0);
    }
  }, true);

  // 4) Premier passage
  sync();
})();
